import clsx from 'clsx'
import { NavLink, Outlet } from 'react-router-dom'

import classes from './styles.module.scss'

export function AppLayoutPublico(): JSX.Element {
  return (
    <>
      <header className="cabecalho-sistema">
        <div className="cabecalho-sistema__container-primario">
          <NavLink to="/" className={classes.botaoLogo} replace>
            <img
              className={clsx('cabecalho-sistema__logo', classes.icone)}
              width="33"
              src="/assets/images/logo-horus-branco.svg"
              alt="Logotipo do Horus"
            />
          </NavLink>
        </div>
        <div className="cabecalho-sistema__container-secundario">
          <NavLink
            to="/publico/documentos"
            className={classes.botaoVoltar}
            replace
          >
            <i className="far fa-sign-out dropdown__icone" />
            Sair
          </NavLink>
        </div>
      </header>
      <Outlet />
    </>
  )
}
